import clsx from 'clsx';
import React from 'react';
import dlsStyles from '../../styles/dls.css';
import styles from './ColumnContent.scss';
import { appendQueryToUrl } from '../../utils/navigationUtils';

type ColumnLink = {
  key: string;
  label: string;
  url: string;
  linknav: string;
  description?: string;
};

type Column = {
  key: string;
  header: string;
  columnLinks: ColumnLink[];
};

type MenuItem = {
  key: string;
  columns: Column[];
};

type ColumnContentProps = {
    menuItem: MenuItem;
}
const ColumnContent = ({ menuItem }: ColumnContentProps) => (
  <div
    className={`${dlsStyles['nav-menu']} ${dlsStyles['nav-menu-full']} ${dlsStyles.flex} ${dlsStyles['flex-justify-between']} ${styles.navMenu}`}
    style={{ display: 'none' }}
  >
    {menuItem.columns.map((column) => (
      <div className={clsx(dlsStyles['nav-menu-section'], styles.menuColumn, dlsStyles['radius-none'])} key={column.key}>
        { column.header && <h2 className={`${dlsStyles['body-bold']} ${dlsStyles['color-text-regular']} ${dlsStyles['dls-black']}`}>{column.header}</h2>}
        <ul aria-label={column.header}>
          { column.columnLinks.length > 0 && column.columnLinks.map((link) => (
            <li className={`${dlsStyles['nav-item']}`} key={link.key}>
              <a className={`${dlsStyles['nav-link']}`} href={appendQueryToUrl(link.url, link.linknav)} data-testid="desktop-link">
                <span>{link.label}</span>
              </a>
              {link.description && (
                <p className={`${dlsStyles.body} ${dlsStyles['dls-black']} ${dlsStyles['text-wrap']}`}>
                  <span>{link.description}</span>
                </p>
              )}
            </li>
          ))}
        </ul>
      </div>
    ))}
  </div>
);

export default ColumnContent;
